<template>
  <div class="modal">
    <b-modal ref="modal" content-class="shadow" hide-footer :title="title">
      <div class="d-block text-center" v-html="question"></div>
      <b-button
        variant="primary"
        block
        @click="
          hideModal();
          yesCallback();
        "
        >{{ yesActionText }}</b-button
      >
      <b-button
        variant="secondary"
        block
        @click="
          hideModal();
          noCallback();
        "
        >{{ noActionText }}</b-button
      >
    </b-modal>
  </div>
</template>

<script>
import { BButton, BModal } from "bootstrap-vue";

const reference = "modal";
export default {
  name: "ConfirmationModal",
  components: { BButton, BModal },
  props: {
    title: String,
    question: String,
    yesActionText: String,
    noActionText: String,
    yesCallback: Function,
    noCallback: Function
  },
  methods: {
    showModal: function() {
      this.$refs[reference].show();
    },
    hideModal: function() {
      this.$refs[reference].hide();
    },
    resetProperties: function() {
      this.title = "";
      this.question = "";
      this.yesActionText = "";
      this.noActionText = "";
      this.yesCallback = () => null;
      this.noCallback = () => null;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
